import { render, staticRenderFns } from "./left1.vue?vue&type=template&id=6db2fa0b&scoped=true"
import script from "./left1.vue?vue&type=script&lang=js"
export * from "./left1.vue?vue&type=script&lang=js"
import style0 from "./left1.vue?vue&type=style&index=0&id=6db2fa0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db2fa0b",
  null
  
)

export default component.exports